import { Component, OnInit, Input, Inject, ElementRef, ViewChild } from '@angular/core';
import { MatDialogRef, MatDialog, MAT_DIALOG_DATA } from '@angular/material';
import { Contacto } from '../../../interfaces/contacto';
import { FormControl } from '@angular/forms';
import { Telefono, telefonoValidator } from '../../telefono/telefono.component';

export interface DialogData {
  contacto: Contacto | any;
}

@Component({
  selector: 'app-enviar-whatsapp',
  templateUrl: './enviar-whatsapp.component.html',
  styleUrls: ['./enviar-whatsapp.component.scss']
})

export class EnviarWhatsappComponent implements OnInit {
  tooltipDir: string = 'below';
  @Input() contacto: Contacto | any;
  constructor(
    public dialog: MatDialog,
  ) { }

  ngOnInit() {
  }

  enviarWhatsapp(contacto): void {
    const dialogRef = this.dialog.open(DialogEnviarWhatsapp, {
      width: '20vw',
      data: { contacto }
    });
  }

}

@Component({
  selector: 'dialog-enviar-whatsapp',
  templateUrl: 'dialog-enviar-whatsapp.html',
  styleUrls: ['./enviar-whatsapp.component.scss']
})

export class DialogEnviarWhatsapp {
  contacto: Contacto = null;
  constructor(
    private dialogRef: MatDialogRef<DialogEnviarWhatsapp>,
    @Inject(MAT_DIALOG_DATA) public data: DialogData,
  ) { }

  ngOnInit() {
    // console.log(this.data.contacto);
    if (this.data.contacto !== undefined) {
      this.contacto = new Contacto(
        this.data.contacto.nombre,
        this.data.contacto.email,
        this.data.contacto.telefono,
        this.data.contacto.celular,
        this.data.contacto.tipoContacto,
        this.data.contacto.IdContacto,
        this.data.contacto.interno
      )
    } else {
      this.contacto = new Contacto();
    }
  }

  enviarWhatsapp() {
    let url = "https://web.whatsapp.com/send?phone=" + this.contacto.celularCodigoPais + this.contacto.celularCodigoArea + this.contacto.celularNumero;
    let titulo = "Enviar whatsapp a [" + this.contacto.celularCodigoArea + this.contacto.celularNumero + "]";
    this.openPopupOnCenterScreen(url, titulo, '800', '600');
  }

  openPopupOnCenterScreen(url, title, w, h) {
    // Fixes dual-screen position                         Most browsers      Firefox
    var dualScreenLeft = window.screenLeft != undefined ? window.screenLeft : window.screenX;
    var dualScreenTop = window.screenTop != undefined ? window.screenTop : window.screenY;

    var width = window.innerWidth ? window.innerWidth : document.documentElement.clientWidth ? document.documentElement.clientWidth : screen.width;
    var height = window.innerHeight ? window.innerHeight : document.documentElement.clientHeight ? document.documentElement.clientHeight : screen.height;

    var left = ((width / 2) - (w / 2)) + dualScreenLeft;
    var top = ((height / 2) - (h / 2)) + dualScreenTop;
    var newWindow = window.open(url, title, 'scrollbars=yes, width=' + w + ', height=' + h + ', top=' + top + ', left=' + left);

    // Puts focus on the newWindow
    if (window.focus) {
      newWindow.focus();
    }
  }

  onNoClick(): void {
    this.dialogRef.close();
  }
}
